<template>
  <div>
        <div  class="img-box">
            <img style="width:80%;margin:10px 0;"   v-if="classObj.openSidebar"   src="@/assets/aierlogo3.png" alt="">
            <img style="width:80%;margin:10px 0;"   v-if="classObj.hideSidebar"    src="@/assets/aierlogo_icon.png" alt="">
          <!-- <img  :class="classObj"  :src='?"@/assets/aierlogo_icon.png":""' alt=""> -->
        </div>
        <el-menu
            :default-active="activeMenu"
            :collapse="isCollapse"
            :unique-opened="false"
            :collapse-transition="false"
            :default-openeds="['/my']"
            mode="vertical"
        >
            <sidebar-item v-for="(route, index) in routes" :key="index" :item="route" :base-path="route.path" />
        </el-menu>
        <div class="goto-market" @click="handleGotoMarket">
          <item icon="zhineng" :title="$t('components.sidebar.gotoMarket')" />
        </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Logo from './Logo'
import SidebarItem from './SidebarItem'
import variables from '@/styles/variables.scss'
import Item from './Item'
import { gotoMarket } from "@/utils/auth";

export default {
  components: { SidebarItem, Logo, Item },
  computed: {
    ...mapGetters([
      'sidebar'
    ]),
    routes() {
      return this.$router.options.routes
    },
    activeMenu() {
      const route = this.$route
      const { meta, path } = route
      // if set path, the sidebar will highlight the path you set
      if (meta.activeMenu) {
        return meta.activeMenu
      }
      return path
    },
    classObj() {
        return {
            hideSidebar: !this.sidebar.opened,
            openSidebar: this.sidebar.opened,
        }
    },
    variables() {
      return variables
    },
    isCollapse() {
      return !this.sidebar.opened
    }
  },
  methods: {
    handleGotoMarket() {
      gotoMarket()
    }
  }
}
</script>

<style lang="scss" scoped>
.img-box{
  text-align: center
}
::v-deep .el-menu {
    height: 100%;
     border-right: none;
}
.openSidebar{

}
.hideSidebar{

}
.goto-market {
  width: 100%;
  height: 50px;
  background-color: #f0f2f5;
  line-height: 50px;
  color: #303133;
  cursor: pointer;
  font-size: 14px;
  position: absolute;
  bottom: 0;
  padding-left: 20px;
}
.goto-market:hover {
  color: #4878e7;
}
</style>

